import { Link } from "react-router-dom";

export default function ComingSoon({ title, description, backTo = "/", backLabel = "Back" }: {
  title: string;
  description: string;
  backTo?: string;
  backLabel?: string;
}) {
  return (
    <div className="space-y-6">
      <Link to={backTo} className="text-sm text-slate-500 hover:text-slate-700">← {backLabel}</Link>
      <div>
        <h1 className="text-3xl font-semibold text-liaise-navy">{title}</h1>
        <p className="text-slate-600 mt-1">{description}</p>
      </div>
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6">
        <h2 className="font-medium text-amber-900">Coming soon</h2>
        <p className="text-amber-800 text-sm mt-2">
          This section is on the build list. Reimbursement + approvals are live; this part comes next.
        </p>
      </div>
    </div>
  );
}
